import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function ProductPresentation() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-324">
      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-325">
        <div className="text-center space-y-8" data-id="element-326">
          <p className="text-sm font-bold text-gold-primary uppercase tracking-widest" data-id="element-327">
            Presentando
          </p>

          <div className="bg-gradient-to-b from-navy-light to-navy-dark p-8 md:p-12 rounded-3xl border-2 border-gold-primary shadow-[0_0_50px_rgba(212,175,55,0.1)] max-w-3xl mx-auto" data-id="element-328">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-gold-primary leading-tight mb-6" data-id="element-329">
              "El Dinero Que El IRS Te Debe y Nadie Te Dijo Cómo Reclamar"
            </h2>

            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-10" data-id="element-330">
              El manual en español que le da vuelta a las reglas del IRS a tu
              favor — 100% legal, 100% accionable, sin abogados ni preparadores
              caros.
            </p>

            <div className="flex justify-center py-4" data-id="element-331">
              <div className="relative w-full max-w-sm mx-auto" data-id="element-332">
                <div className="absolute inset-0 bg-gold-primary/15 blur-3xl rounded-full" data-id="element-333"></div>
                <img src="https://cdn.magicpatterns.com/uploads/1fF4Tm21S49eNCpVTbx8Sv/irsTeDebe.png" alt="El Dinero Que El IRS Te Debe - Guía Experta de Declaración" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-334" />
              </div>
            </div>
          </div>

          <div className="max-w-3xl mx-auto space-y-4 text-gray-200 pt-4" data-id="element-335">
            <p className="text-xl md:text-2xl leading-relaxed" data-id="element-336">
              Este no es un libro de teoría. No tiene lenguaje legal confuso. No
              asume que tienes título universitario.
            </p>

            <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-337">
              Es una guía directa, en tu idioma, escrita para el trabajador
              latino en USA que está listo para dejar de dejar ir lo que siempre
              fue suyo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}